import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import { useState } from 'react';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize, KTBSButtonType } from 'general/components/OtherKeenComponents/KTBSButton';

function CoinvestorInvestmentInfo({
    formikProps,
    commissionRateGroup,
    agencyRole,
}) {
    const { t } = useTranslation();


    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Doanh thu theo kW điện bán ra
                    </span>
                </Modal.Title>
            </Col>
            <Col md={6} className="pr-2">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('Dành cho ô tô')}
                        </span>
                    }
                    inputName={`energyCommissionForCar`}
                    additionalClassName=" mb-3"
                    inputElement={
                        <FastField name={`energyCommissionForCar`}>
                            {({ field, form, meta }) => {
                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        placeholder={'Nhập số'}
                                        isValid={_.isEmpty(meta.error)}
                                        isTouched={meta.touched}
                                        feedbackText={meta.error}
                                        unit="VNĐ/kWh"
                                    />
                                );
                            }}
                        </FastField>
                    }
                // isRequired={true}
                />
            </Col>
            <Col md={6} className="pl-2">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('Dành cho xe máy')}
                        </span>
                    }
                    inputName={`energyCommissionForBike`}
                    additionalClassName=" mb-3"
                    inputElement={
                        <FastField name={`energyCommissionForBike`}>
                            {({ field, form, meta }) => {
                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        placeholder={'Nhập số'}
                                        isValid={_.isEmpty(meta.error)}
                                        isTouched={meta.touched}
                                        feedbackText={meta.error}
                                        unit="VNĐ/kWh"
                                    />
                                );
                            }}
                        </FastField>
                    }
                // isRequired={true}
                />
            </Col>
            {agencyRole === 'COINVESTOR' && (
                <>
                    <Col md={12}>
                        <div
                            className="my-2"
                            style={{
                                borderBottom: `1px dashed ${AppColors.gray[300]}`,
                            }}
                        />
                    </Col>
                    <Col md={12}>
                        <Modal.Title className="mb-3">
                            <span
                                className="font-weight-bolder"
                                style={{ fontSize: 18, color: AppColors.gray[900] }}
                            >
                                Doanh thu theo số phút sạc quá giờ
                            </span>
                        </Modal.Title>
                    </Col>
                    <Col md={6} className="pr-2">
                        <KTFormGroup
                            label={
                                <span
                                    className="font-weight-boldest"
                                    style={{
                                        fontSize: 13,
                                        color: AppColors.gray[800],
                                    }}
                                >
                                    {t('Dành cho ô tô')}
                                </span>
                            }
                            inputName={`overchargeCommissionValue`}
                            additionalClassName=" mb-3"
                            inputElement={
                                <FastField name={`overchargeCommissionValue`}>
                                    {({ field, form, meta }) => {
                                        return (
                                            <KTFormInput
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                }}
                                                onBlur={() => {
                                                    form.setFieldTouched(field.name, true);
                                                }}
                                                enableCheckValid
                                                type={KTFormInputType.currency}
                                                placeholder={'Nhập số'}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                unit="VNĐ/kWh"
                                            />
                                        );
                                    }}
                                </FastField>
                            }
                        // isRequired={true}
                        />
                    </Col>
                </>
            )}
        </Row>
    )
}

export default CoinvestorInvestmentInfo;